import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BrowserRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '6LdjH5osAAAAAAoD8-b-TK0f7XweaMnmaGprJq-A';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </StrictMode>,
);
